var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1239 3977 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8a8a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(1239 3977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-1",
    d: "M72.969,302H7.031A7.039,7.039,0,0,0,0,309.031v18.75a7.039,7.039,0,0,0,7.031,7.031H72.969A7.039,7.039,0,0,0,80,327.781v-18.75A7.039,7.039,0,0,0,72.969,302Zm2.344,25.781a2.346,2.346,0,0,1-2.344,2.344H7.031a2.346,2.346,0,0,1-2.344-2.344v-18.75a2.346,2.346,0,0,1,2.344-2.344H72.969a2.346,2.346,0,0,1,2.344,2.344Z",
    transform: "translate(0 -254.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-1",
    d: "M70.452,369.031l3.067-3.017a2.344,2.344,0,0,0-3.287-3.342l-3.122,3.071-3.122-3.071a2.344,2.344,0,1,0-3.287,3.342l3.067,3.017L60.7,372.048a2.344,2.344,0,1,0,3.287,3.342l3.122-3.071,3.122,3.071a2.344,2.344,0,1,0,3.287-3.342Z",
    transform: "translate(-50.625 -305.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-1",
    d: "M224.376,372.061l-3.03-3.03,3.03-3.03a2.344,2.344,0,1,0-3.315-3.315l-3.03,3.03-3.03-3.03A2.344,2.344,0,0,0,211.686,366l3.03,3.03-3.03,3.03A2.344,2.344,0,1,0,215,375.376l3.03-3.03,3.03,3.03a2.344,2.344,0,1,0,3.315-3.315Z",
    transform: "translate(-178.031 -305.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-1",
    d: "M374.376,372.061l-3.03-3.03,3.03-3.03a2.344,2.344,0,1,0-3.315-3.315l-3.03,3.03-3.03-3.03A2.344,2.344,0,1,0,361.686,366l3.03,3.03-3.03,3.03A2.344,2.344,0,1,0,365,375.376l3.03-3.03,3.03,3.03a2.344,2.344,0,1,0,3.315-3.315Z",
    transform: "translate(-304.593 -305.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-1",
    d: "M179.125,19.466V11.719a11.719,11.719,0,0,0-23.437,0v7.747A7.042,7.042,0,0,0,151,26.094v9.375a7.039,7.039,0,0,0,7.031,7.031h18.75a7.039,7.039,0,0,0,7.031-7.031V26.094A7.042,7.042,0,0,0,179.125,19.466Zm-18.75-7.747a7.031,7.031,0,0,1,14.063,0v7.344H160.375Zm18.75,23.75a2.346,2.346,0,0,1-2.344,2.344h-18.75a2.346,2.346,0,0,1-2.344-2.344V26.094a2.346,2.346,0,0,1,2.344-2.344h18.75a2.346,2.346,0,0,1,2.344,2.344Z",
    transform: "translate(-127.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-1",
    d: "M222.719,182h-9.375a2.344,2.344,0,0,0,0,4.688h9.375a2.344,2.344,0,1,0,0-4.687Z",
    transform: "translate(-178.031 -153.563)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.3c68a65a21d80cda041e1f1a973600aa.svg";
export { ForwardRef as ReactComponent };